import {
    createContext,
    useContext,
    useEffect
} from "react";
import type {
    DropdownMenuRadioContextType,
    DropdownMenuLevelContextType,
    DropdownMenuSubContextType,
    DropdownMenuContextType
} from "./type";
import {
    warnOnce
} from "../../utils/development";

export const DropdownMenuContext = createContext<DropdownMenuContextType | undefined>(undefined);

export const DropdownMenuLevelContext = createContext<DropdownMenuLevelContextType | undefined>(undefined);

export const DropdownMenuSubContext = createContext<DropdownMenuSubContextType | undefined>(undefined);

export const DropdownMenuRadioContext = createContext<DropdownMenuRadioContextType | undefined>(undefined);

export const useDropdownMenuContext = ({
    part
}: {
    part: string;
}): DropdownMenuContextType | undefined => {
    const context = useContext(DropdownMenuContext);

    useEffect(() => {
        if(context) {
            return;
        }

        warnOnce({
            message: `DropdownMenu.${part}: must be rendered inside <DropdownMenu> or <ContextMenu>.`
        });
    }, [
        context,
        part
    ]);

    return context;
};

export const useDropdownMenuLevelContext = ({
    part
}: {
    part: string;
}): DropdownMenuLevelContextType | undefined => {
    const context = useContext(DropdownMenuLevelContext);

    useEffect(() => {
        if(context) {
            return;
        }

        warnOnce({
            message: `DropdownMenu.${part}: must be rendered inside <DropdownMenu.Content> or <DropdownMenu.SubContent>.`
        });
    }, [
        context,
        part
    ]);

    return context;
};
